<template>
  <v-dialog
    v-bind:model-value="dialog"
    fullscreen
    :scrim="false"
    transition="dialog-bottom-transition"
    scrollable
    persistent
  >

  <v-card >
    <v-card-title>
      <v-toolbar flat color="primary" >
        <v-toolbar-title>
          {{$t('menus.resourceLimits.buyAddons')}}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-card-title>

    <v-card-text class="">
      <v-row  style="height: 100%;">
        <v-col cols="12" offset="0" sm=4 offset-sm="1" class="d-flex justify-center align-center">
          <div>

            <h2 class="mb-4">
              {{$t('menus.resourceLimits.selectedAddons')}}:
            </h2>

            <div class="d-flex justify-space-between">
              <ul class="mb-4">
                <li v-if="usersItems != 0"> {{usersItems}} x {{getUserAddon.product.name}}</li>
                <li v-if="clientuserItems != 0"> {{clientuserItems}} x {{getClientuserAddon.product.name}}</li>
                <li v-if="storageItems != 0"> {{storageItems}} x {{getStorageAddon.product.name}}</li>
                <li v-if="bandwidthItems != 0"> {{bandwidthItems}} x {{getBandwidthAddon.product.name}}</li>
                <li v-if="creditItems != 0"> {{creditItems}} x {{getCreditsAddon.product.name}}</li>
                <!-- <li v-if="transcriptItems != 0"> {{transcriptItems}} x {{getTranscriptAddon.product.name}}</li> -->
                <!-- <li v-if="translateItems != 0"> {{translateItems}} x {{getTranslateAddon.product.name}}</li> -->
                <!-- <li v-if="rekognitionItems != 0"> {{rekognitionItems}} x {{getRekognitionAddon.product.name}}</li> -->
              </ul>
              <div class="pl-8">
                <div v-if="usersItems != 0">
                  € {{(usersItems * getUserAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getUserAddon.price)}}
                </div>
                <div v-if="clientuserItems != 0">
                  € {{(clientuserItems * getClientuserAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getClientuserAddon.price)}}
                </div>
                <div v-if="storageItems != 0">
                  € {{(storageItems * getStorageAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getStorageAddon.price)}}
                </div>
                <div v-if="bandwidthItems != 0">
                  € {{(bandwidthItems * getBandwidthAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getBandwidthAddon.price)}}
                </div>
                <div v-if="creditItems != 0">
                  € {{(creditItems * getCreditsAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getCreditsAddon.price)}}
                </div>
                <!-- <div v-if="transcriptItems != 0">
                  € {{(transcriptItems * getTranscriptAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getTranscriptAddon.price)}}
                </div> -->
                <!-- <div v-if="translateItems != 0">
                  € {{(translateItems * getTranslateAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getTranslateAddon.price)}}
                </div> -->
                <!-- <div v-if="rekognitionItems != 0">
                  € {{(rekognitionItems * getRekognitionAddon.price.price / 100).toFixed(2)}}
                  {{getPricePeriod(getRekognitionAddon.price)}}
                </div> -->
              </div>
            </div>

            <hr/>

            <div class="d-flex justify-space-between mt-4">
              <h3>{{$t('menus.resourceLimits.total')}}: </h3>
              <h3>€ {{getTotalPrice.toFixed(2)}}</h3>
            </div>
          </div>
        </v-col>

        <v-col cols="12" offset="0" sm=4 offset-sm="2" class="d-flex flex-column justify-center align-center text-center ">
          <div class="text-left" style="width: 100%;">

          </div>
          <div class="text-left" style="width: 100%;">
            <p>
              {{$t('menus.resourceLimits.infoLine1')}}
            </p>
            <p v-html="$t('menus.resourceLimits.infoLine2', {price:getTotalPrice.toFixed(2)})">
            </p>
            <p>
              {{$t('menus.resourceLimits.infoLine3')}}
            </p>
          </div>

          <v-checkbox
            v-model="iAgree"
            v-bind:label="$t('menus.resourceLimits.iAgreeAndUnderstand')"
          >
          </v-checkbox>

          <div v-if="errorMessage" class="bg-error mb-4" style="width: 100%;">
            {{errorMessage}}
          </div>
          <div v-if="successMessage" class="bg-success mb-4" style="width: 100%;">
            {{successMessage}}
          </div>

          <v-btn
            v-bind:loading="isLoading"
            v-bind:disabled="isSubmitDisabled"
            v-on:click="buyAddons"
            color="primary"
            class=""
          >
            {{$t('menus.resourceLimits.buyAddons')}}
          </v-btn>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useNodeStore } from '@/stores/NodeStore.js';
import { useSystemStore } from '@/stores/SystemStore.js'
import { useServiceStore } from '@/stores/ServiceStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["resetQuantity", "input"],
  mixins: [DialogActionKeys],
  name: "BuyAddonsDialog",

  props: {
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    usersItems: {
      type: Number,
      required: true,
    },
    clientuserItems: {
      type: Number,
      required: true,
    },
    storageItems: {
      type: Number,
      required: true,
    },
    bandwidthItems: {
      type: Number,
      required: true,
    },
    creditItems: {
      type: Number,
      required: true,
    },
    // transcriptItems: {
    //   type: Number,
    //   required: true,
    // },
    // translateItems: {
    //   type: Number,
    //   required: true,
    // },
    // rekognitionItems: {
    //   type: Number,
    //   required: true,
    // },
  },

  data: function() {
    return {
      iAgree: false,
      isLoading: false,
      isSubmitted: false,
      successMessage: "",
      errorMessage: "",
    };
  },

  watch: {
    dialog: function(newValue) {
      // refresh the limits if the user has bought new addons
      if (!newValue && this.isSubmitted) {
        const payload = {
          accessPointId: this.accessPointId
        };

        const serviceStore = useServiceStore();
        serviceStore.refreshLimits(payload);
      }

      if (!newValue) {
        this.successMessage = "";
        this.errorMessage = "";
        this.isSubmitted = false;
        this.iAgree = false;
      }
    }
  },

  methods: {
    emitResetQuantityEvent: function() {
      this.$emit("resetQuantity", true);
    },
    buyAddons: function() {
      if (!this.iAgree) {
        return;
      }

      if (!this.currentNode || !this.currentNode.id) {
        return;
      }

      let formData = {
        contextNodeId: this.currentNode.id,
        body: {},
      };

      if (this.usersItems != 0) {
        formData.body[this.getUserAddon.price.id] = this.usersItems;
      }
      if (this.clientuserItems != 0) {
        formData.body[this.getClientuserAddon.price.id] = this.clientuserItems;
      }
      if (this.storageItems != 0) {
        formData.body[this.getStorageAddon.price.id] = this.storageItems;
      }
      if (this.bandwidthItems != 0) {
        formData.body[this.getBandwidthAddon.price.id] = this.bandwidthItems;
      }
      if (this.creditItems != 0) {
        formData.body[this.getCreditsAddon.price.id] = this.creditItems;
      }
      // if (this.transcriptItems != 0) {
      //   formData.body[this.getTranscriptAddon.price.id] = this.transcriptItems;
      // }
      // if (this.translateItems != 0) {
      //   formData.body[this.getTranslateAddon.price.id] = this.translateItems;
      // }
      // if (this.rekognitionItems != 0) {
      //   formData.body[this.getRekognitionAddon.price.id] = this.rekognitionItems;
      // }


      let self = this;
      this.isLoading = true;
      const systemStore = useSystemStore();
      systemStore.buyAddons(formData)
      .then(function() {
        self.successMessage = self.$t('menus.resourceLimits.purchaseSucceeded');
        self.emitResetQuantityEvent();
        self.isSubmitted = true;
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          self.errorMessage = error.response.data.error.message;
        } else {
          self.errorMessage = "Error!";
        }
      })
      .then(function() {

        self.isLoading = false;
      });
    }
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    },
    accessPointId: function () {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    currentNode: function() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    getSubscription: function() {
      const systemStore = useSystemStore();
      return systemStore.getSubscription;
    },
    getAddonByName: function() {
      return (name) => {
        if (this.getSubscription &&
            this.getSubscription.addons &&
            this.getSubscription.addons[name]) {
          return this.getSubscription.addons[name];
        }

        return null;
      }
    },
    getUserAddon: function() {
      return this.getAddonByName('users');
    },
    getClientuserAddon: function() {
      return this.getAddonByName('clientuser');
    },
    getStorageAddon: function() {
      return this.getAddonByName('storage');
    },
    getBandwidthAddon: function() {
      return this.getAddonByName('bandwidth');
    },
    getCreditsAddon: function() {
      return this.getAddonByName('credits');
    },
    // getTranscriptAddon: function() {
    //   return this.getAddonByName('transcription');
    // },
    // getTranslateAddon: function() {
    //   return this.getAddonByName('translation');
    // },
    // getRekognitionAddon: function() {
    //   return this.getAddonByName('rekognition');
    // },
    getTotalPrice: function() {

      if (!this.getSubscription || !this.getSubscription.addons) {
        return 0;
      }

      let sum = 0;

      sum += this.getUserAddon        ? this.usersItems       * this.getUserAddon.price.price         / 100 : 0;
      sum += this.getClientuserAddon  ? this.clientuserItems  * this.getClientuserAddon.price.price   / 100 : 0;
      sum += this.getStorageAddon     ? this.storageItems     * this.getStorageAddon.price.price      / 100 : 0;
      sum += this.getBandwidthAddon   ? this.bandwidthItems   * this.getBandwidthAddon.price.price    / 100 : 0;
      sum += this.getCreditsAddon     ? this.creditItems      * this.getCreditsAddon.price.price      / 100 : 0;
      // sum += this.getTranscriptAddon  ? this.transcriptItems  * this.getTranscriptAddon.price.price   / 100 : 0;
      // sum += this.getTranslateAddon   ? this.translateItems   * this.getTranslateAddon.price.price    / 100 : 0;
      // sum += this.getRekognitionAddon ? this.rekognitionItems * this.getRekognitionAddon.price.price  / 100 : 0;

      return sum;
    },
    getPricePeriod: function() {
      return (price) => {
        if (
          this.getSubscription &&
          this.getSubscription.interval &&
          this.getSubscription.interval == 'year' &&
          price.type == "recurring"
        ) {
          return this.$t('menus.resourceLimits.perYear');
        }

        switch (price.type) {
          case "recurring": return this.$t('menus.resourceLimits.perMonth');
          case "one_time": return this.$t('menus.resourceLimits.oneTime');
          default: return "";
        }
      }
    },
    isSubmitDisabled: function() {
      return !this.iAgree || this.isLoading || this.isSubmitted;
    }
  }
};
</script>

<style>

</style>
